import EmailsView from '../views/pages/settings/emails/EmailsView.vue'
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/settings/emails',
        name: 'settings-emails',
        component: EmailsView,
        meta: {
            requiresAuth: true,
            subNavType: 'ACCOUNT_SETTINGS'
        }
    },
];

export default routes;